module.exports = __webpack_public_path__ + "img/portrait-054.13059e8e.jpg";